import React from 'react';
import HabitCard from './HabitCard';

const HabitList = ({ habits, onToggle, onDelete }) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-6 border border-white/20">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Your Habits</h3>
      {habits.length === 0 ? (
        <div className="text-center py-12">
          <div className="text-6xl mb-4">🎯</div>
          <p className="text-gray-600 text-lg font-medium">No habits yet — let's build one!</p>
          <p className="text-gray-500 mt-2">Add your first habit above to get started.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {habits.map((habit) => (
            <HabitCard 
              key={habit.id} 
              habit={habit} 
              onToggle={onToggle}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HabitList;
